import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const ADMINS_QUERY_KEY = 'admins';

// Custom hook for fetching admins
export const useAdmins = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: [ADMINS_QUERY_KEY, page, limit],
    queryFn: () => apiClient.admins.getAll(page, limit),
    keepPreviousData: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

// Custom hook for creating an admin
export const useCreateAdmin = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (adminData) => apiClient.admins.create(adminData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMINS_QUERY_KEY] });
    },
  });
};

// Custom hook for updating an admin
export const useUpdateAdmin = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, adminData }) => apiClient.admins.update(id, adminData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMINS_QUERY_KEY] });
    },
  });
};

// Custom hook for deleting an admin
export const useDeleteAdmin = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => apiClient.admins.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMINS_QUERY_KEY] });
    },
  });
};

// Custom hook for getting a single admin
export const useAdmin = (id) => {
  return useQuery({
    queryKey: [ADMINS_QUERY_KEY, id],
    queryFn: () => apiClient.admins.getById(id),
    enabled: !!id,
  });
}; 